// extracted by mini-css-extract-plugin
export var LogoWrapper = "mirosign-logo-module--LogoWrapper--9722b";
export var Logo = "mirosign-logo-module--Logo--c9138";
export var Logo__fill = "mirosign-logo-module--Logo__fill--26ca8";